import { initialJobsState, JobsState } from './jobs/state';

export const UserRole = {
  ADMIN: 'admin',
  RECRUITER: 'recruiter',
  CANDIDATE: 'candidate',
  GUEST: 'guest',
} as const;

export type Role = (typeof UserRole)[keyof typeof UserRole];

export interface SharedState {
  jobs: JobsState;
  role: Role;
}

export const initialState = {
  jobs: initialJobsState,
  role: UserRole.GUEST,
};
